import { Accordion, AccordionDetails, AccordionSummary, FormControl, FormControlLabel, FormHelperText, Grid2, Switch } from "@mui/material";
import MaterialTypography from "../../../../components/MaterialTypography";
import { ArrowDownward } from "@mui/icons-material";
import MaterialInput from "../../../../components/MaterialInput";

const FieldDetailsAccordion = ({
  expanded,
  onAccordionChange,
  formData,
  handleChange,
  pageMode,
  accordionSx,
  descriptionSx
}) => {    
  return (
    <Accordion
      expanded={expanded}
      onChange={(_, isExpanded) => onAccordionChange(isExpanded ? "fieldDetails" : false)}
      sx={accordionSx}
    >
      <AccordionSummary expandIcon={<ArrowDownward />}>
        <Grid2 container>
          <Grid2 size={{sm: 6, xs: 12 }}>
            <MaterialTypography
              component="span"
              variant="body2"
              fontWeight="bold"
            >
              Field Details
            </MaterialTypography>
            <MaterialTypography
              component="div"
              variant="caption"
              sx={descriptionSx}
            >
              Basic information about the field such as name, label, and description.
            </MaterialTypography>
          </Grid2>
        </Grid2>
      </AccordionSummary>

      <AccordionDetails>
        <Grid2 container spacing={1}>
          {/* name */}
          <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
            <MaterialTypography component="label" variant="caption" fontWeight="bold">
              Name*
            </MaterialTypography>
            <MaterialInput
              name="name"
              placeholder="eg. Field Name"
              value={formData.name}
              onChange={handleChange}
              success={formData.nameStatus === "success"}
              error={formData.nameStatus === "error"}
              disabled={pageMode === "view"}
            />
            {formData.nameStatus === "error" && (
              <FormControl error>
                <FormHelperText>
                  Name should be a minimum 1 character & maximum 100 characters long.
                </FormHelperText>
              </FormControl>
            )}
          </Grid2>

          {/* label */}
          <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
            <MaterialTypography component="label" variant="caption" fontWeight="bold">
              Label*
            </MaterialTypography>
            <MaterialInput
              name="label"
              placeholder="eg. Field Label"
              value={formData.label}
              onChange={handleChange}
              success={formData.labelStatus === "success"}
              error={formData.labelStatus === "error"}
              disabled={pageMode === "view"}
            />
            {formData.labelStatus === "error" && (
              <FormControl error>
                <FormHelperText>
                  Label should be a minimum 1 character & maximum 100 characters long.
                </FormHelperText>
              </FormControl>
            )}
          </Grid2>

          {/* description */}
          <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
            <MaterialTypography component="label" variant="caption" fontWeight="bold">
              Description {/* Fixed typo */}
            </MaterialTypography>
            <MaterialInput
              name="description"
              placeholder="eg. Description"
              value={formData.description}
              onChange={handleChange}
              success={formData.descriptionStatus === "success"}
              error={formData.descriptionStatus === "error"}
              disabled={pageMode === "view"}
              multiline
              rows={2}
            />
            {formData.descriptionStatus === "error" && (
              <FormControl error>
                <FormHelperText>
                  Description should be a minimum 1 character & maximum 150 characters long.
                </FormHelperText>
              </FormControl>
            )}
          </Grid2>

          {/* isRequired */}
          <Grid2 size={{lg:3, md:3, sm: 6, xs: 6 }}>
            <MaterialTypography component="label" variant="caption" fontWeight="bold">
              Required
            </MaterialTypography>
            <FormControlLabel
              control={
                <Switch
                  checked={formData.isRequired}
                  disabled={pageMode === "view"}
                  onChange={(e) =>
                    handleChange({
                      target: {
                        name: "isRequired",
                        value: e.target.checked,
                      },
                    })
                  }
                  color="primary"
                />
              }
              label={
                <MaterialTypography variant="caption" fontWeight="bold">
                  {formData?.isRequired ? "Yes" : "No"}
                </MaterialTypography>
              }
              sx={{ marginLeft: 0 }}
            />
          </Grid2>

          {/* isActive */}
          <Grid2 size={{lg:3, md:3, sm: 6, xs: 6 }}>
            <MaterialTypography component="label" variant="caption" fontWeight="bold">
              Active {/* Fixed typo */}
            </MaterialTypography>
            <FormControlLabel
              control={
                <Switch
                  checked={formData.isActive}
                  disabled={pageMode === "view"}
                  onChange={(e) =>
                    handleChange({
                      target: {
                        name: "isActive",
                        value: e.target.checked,
                      },
                    })
                  }
                  color="primary"
                />
              }
              label={
                <MaterialTypography variant="caption" fontWeight="bold">
                  {formData?.isActive ? "Yes" : "No"}
                </MaterialTypography>
              }
              sx={{ marginLeft: 0 }}
            />
          </Grid2>
        </Grid2>
      </AccordionDetails>
    </Accordion>
  );
};

export default FieldDetailsAccordion;
